import { useEffect, useState } from "react";
import client from "@/api/client";

export function useAssetOptions() {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    client
      .get("/assets")
      .then((res) => {
        setOptions(
          res.data.map((a) => ({
            value: a.asset_id,
            label: a.label,
          })),
        );
      })
      .catch(() => {});
  }, []);

  return options;
}
